export function scrollToElement (element)
{
	window.scrollTo({
		top: element.offsetTop,
		left: 0,
		behavior: 'smooth'
	});
}

export function scrollDownByPixel (element, pixel)
{
	window.scrollTo({
		top: element.offsetTop + pixel,
		left: 0,
		behavior: 'smooth'
	});
}

export function scrollToTop ()
{
	window.scrollTo(0, 0);
}

export function scrollToBottom (element)
{
	element.scrollTop = element.scrollHeight;
}

export function reload ()
{
	location.reload();
}

export function redirect (url)
{
	location.href = url;
}
